import BaseInput from "./BaseInputs/BaseInput";
import TextArea from "./BaseInputs/TextArea";
import AnticipatedDate from "./BaseInputs/AnticipatedDate";
import SelectInput from "./BaseInputs/SelectInput";
import RadioInput from "./BaseInputs/RadioInput";
import DateInput from "./BaseInputs/DateInput/DateInput";
import TimeInput from "./BaseInputs/TimeInput/TimeInput";
import CheckboxInput_old from "./BaseInputs/CheckboxInput_old";
import CheckboxInput from "./BaseInputs/CheckboxInput";
import MultiselectInput from "./BaseInputs/MutiselectInput";
import PhoneInput from "./BaseInputs/PhoneInput";
import WageInput from "./BaseInputs/WageInput";
import CountyselectInput from "./BaseInputs/CountyselectInput";
import CountyselectInputBls from "./BaseInputs/CountyselectInputBls";
import MsaSelectInput from "./BaseInputs/MsaSelectInput";
import TableLoader from "../PrevailingWageLookup/Shared/TableLoader";
import TableEditor from "../PrevailingWageLookup/Shared/TableEditor";
import PageAlert from "./UI/PageAlert";

import NAICSInput from "./NAICSInput";
import SOCInput from "./SOCInput";
import { SocPicker } from "./SocPicker";
import FileUpload from "./FileUpload";
import ApplicationDocuments from "./ApplicationDocuments";
import InlinePrefillerInput from "./Prefiller/InlinePrefillerInput";
import InlineGroupPrefillerInput from "./Prefiller/InlineGroupPrefillerInput";
import CaseLookup from "./BaseInputs/CaseLookup";
import Label from "./Label";
import MinimumWage from "./MinimumWage";
import MinimumWageDisplay from "./MinimumWageDisplay";
import WageCalculator from "./BaseInputs/WageCalculator";
import { goToStepButton } from "../PrevailingWageLookup/goToStepButton";
import WorksiteLinking from "./WorksiteLinking";
import GenericTable from "./GenericTable";
import RegistrationNumberLinking from "../RegistrationNumberLinking";
import PrevailingWageLookup from "../PrevailingWageLookup/Shared/PrevailingWageLookup";
import LinkageTable from "../LinkageTable";
import GenericPrefillButton from "./Prefiller/GenericPrefillButton";

const FieldResolver = (widget) => {
  const formControlsList = {
    // BASE INPUTS
    text: BaseInput,
    text_area: TextArea,
    radio: RadioInput,
    date: DateInput,
    time: TimeInput,
    multiselect: MultiselectInput,
    checkbox_old: CheckboxInput_old,
    checkbox: CheckboxInput,
    anticipated_date: AnticipatedDate,
    select: SelectInput,
    countyselect: CountyselectInput,
    countyselect_bls: CountyselectInputBls,
    msaselect: MsaSelectInput,
    phone: PhoneInput,
    wage: WageInput,
    tableLoader: TableLoader,
    tableEditor: TableEditor,
    generic_table: GenericTable,
    table_linkage: LinkageTable,
    // OFLC INPUTS
    naics: NAICSInput,
    soc: SOCInput,
    soc_picker: SocPicker,
    file_upload: FileUpload,
    application_documents: ApplicationDocuments,
    inlinePrefiller: InlinePrefillerInput,
    InlineGroupPrefillerInput: InlineGroupPrefillerInput,
    job_order_lookup: CaseLookup,
    pw_lookup: PrevailingWageLookup,
    jump_to_step: goToStepButton,
    registration_number_linking: RegistrationNumberLinking,
    // UI Blocks (takes no input)
    label: Label,
    minimum_wage: MinimumWage,
    minimum_wage_display: MinimumWageDisplay,
    alert: PageAlert,
    wage_calculator: WageCalculator,
    worksite_linking: WorksiteLinking,
    generic_prefill_button: GenericPrefillButton,
  };
  return formControlsList[widget] || BaseInput;
};

export default FieldResolver;
